import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import EditableText from "./EditableText";

/**
 * FAQ marketing — question / réponse live-éditables (`{keyPrefix}.{n}.question|answer`).
 */
export default function EditableFaqList({ items = [], keyPrefix }) {
  if (!items.length) return null;

  return (
    <Accordion type="single" collapsible className="space-y-4">
      {items.map((faq, index) => {
        const n = index + 1;
        return (
          <AccordionItem
            key={`${keyPrefix}-${n}`}
            value={`item-${n}`}
            className="bg-white border border-slate-200 shadow-sm rounded-lg px-6"
          >
            <AccordionTrigger className="text-slate-900 hover:text-[#3a00e0]">
              <EditableText
                editKey={`${keyPrefix}.${n}.question`}
                defaultValue={faq.question}
                as="span"
                className="text-left"
              />
            </AccordionTrigger>
            {faq.answer ? (
              <AccordionContent className="text-slate-600">
                <EditableText
                  editKey={`${keyPrefix}.${n}.answer`}
                  defaultValue={faq.answer}
                  as="p"
                  multiline
                />
              </AccordionContent>
            ) : null}
          </AccordionItem>
        );
      })}
    </Accordion>
  );
}
